import React, { useCallback } from "react";

import AntdPagination, { PaginationProps as AntdPaginationProps } from "antd/es/pagination";

import RangeModel from "@mapmycustomers/shared/types/viewModel/internalModel/RangeModel";

import TextGetters from "../../types/TextGetters";

import styles from "./Pagination.module.scss";

interface PaginationProps {
  count: number; // number of records on a current page, can be less than MAP_RECORDS_PAGE_SIZE on the last page
  loading?: boolean;
  onRangeChange?: (range: RangeModel) => void;
  pageSize: number;
  range: RangeModel;
  textGetter: Exclude<TextGetters["paginationTextGetter"], undefined>;
  total: number;
}

const Pagination = ({
  count,
  loading,
  onRangeChange,
  pageSize,
  range,
  textGetter,
  total,
}: PaginationProps) => {
  const visible = !loading && total > 0;
  const hasPages = total > pageSize;

  const currentPage = Math.floor(range.startRow / pageSize) + 1;

  const handleChange = useCallback<NonNullable<AntdPaginationProps["onChange"]>>(
    (page) =>
      onRangeChange?.({
        endRow: page * pageSize,
        startRow: (page - 1) * pageSize,
      }),
    [onRangeChange, pageSize]
  );

  return visible ? (
    <div className={styles.container}>
      <div className={styles.recordCount}>
        {textGetter({ endOffset: range.startRow + count, startOffset: range.startRow + 1, total })}
      </div>

      {hasPages && (
        <div className={styles.pagination}>
          <AntdPagination
            className={styles.numbers}
            current={currentPage}
            onChange={handleChange}
            pageSize={pageSize}
            showLessItems
            showSizeChanger={false}
            total={total}
          />

          <AntdPagination
            className={styles.arrows}
            current={currentPage}
            onChange={handleChange}
            pageSize={pageSize}
            showSizeChanger={false}
            total={total}
          />
        </div>
      )}
    </div>
  ) : null;
};

export default Pagination;
